import React, { useEffect, useState } from "react";
import { fetchImageBlob } from "../../lib/api";
import { ImageIcon } from "lucide-react";

export const AuthImage = ({ path, alt }) => {
  const [url, setUrl] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    let active = true;
    let created = null;
    fetchImageBlob(path)
      .then((u) => { if (active) { created = u; setUrl(u); } })
      .catch(() => active && setErr(true));
    return () => { active = false; if (created) URL.revokeObjectURL(created); };
  }, [path]);

  if (err) return <div className="w-full h-24 grid place-items-center border-2 border-[#2d2d2d] text-white/30"><ImageIcon size={20} /></div>;
  if (!url) return <div className="w-full h-24 bg-[#1a1a1a] animate-pulse border-2 border-[#2d2d2d]" />;
  return <img src={url} alt={alt} className="w-full h-24 object-cover border-2 border-[#2d2d2d]" />;
};
